import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  eyebrow?: string;
  className?: string;
};

export default function FeatureCard({ title, children, icon, eyebrow, className = '' }: Props) {
  return (
    <article className={`grid gap-5 border-b border-emerald-900/10 bg-transparent py-6 transition-colors hover:border-[#D97706]/50 sm:grid-cols-[4.5rem_1fr] ${className}`}>
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-xl text-[#0F766E] shadow-sm">
        {icon}
      </div>
      <div>
        {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#0D6D65]">{eyebrow}</p>}
        <h3 className="mt-3 text-2xl font-semibold tracking-tight text-[#0B2F2A]">{title}</h3>
        <p className="mt-3 text-sm leading-7 text-[#2D4A43]">{children}</p>
      </div>
    </article>
  );
}
